import React, { useEffect } from "react";
import { GeneralTable } from "../GeneralComponents/GeneralTable";
import moment from "moment";
import AddIcon from "@material-ui/icons/Add";
import { SelectorTiposDocumentales } from "./SelectorTiposDocumentales";
import { DocumentaryTRD } from "./DocumentaryTRD";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { DocumentaryViewTRD } from "./DocumentaryViewTRD";
import { useModalAlert } from "../GeneralComponents";

export function ProductionOffice() {
  const [office, setOffice] = React.useState(null);
  const [listOffice, setListOffice] = React.useState([]);
  const [openModalTRD, setOpenModalTRD] = React.useState(false);
  const [openModalTRDSummary, setOpenModalTRDSummary] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(null);
  const [listUnidadAdministrativa, setUnidadAdministrativa] = React.useState(
    [],
  );
  const [listSede, setSede] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(5);
  const [rowCount, setRowCount] = React.useState(0);
  const { showModalAlert } = useModalAlert();

  useEffect(() => {
    loadUnidadAdministrativa();
    loadSedes();
  }, []);

  useEffect(() => {
    loadProductionOffice();
  }, [page, pageSize]);

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handlePageSizeChange = (pageSize) => {
    setPageSize(pageSize);
  };

  const consultarRegistro = async () => {
    const response = await fetch(
      process.env.REACT_APP_PUBLIC_URL + "dependencia/consult",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    );
  };

  const columns = [
    {
      field: "codigo",
      headerName: "CÓDIGO",
      flex: 0.5,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "descripcion",
      headerName: "NOMBRE DE LA DEPENDENCIA",
      type: "string",
      flex: 1.5,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "nombre_unidad_administrativa",
      headerName: "UNIDAD ADMINISTRATIVA",
      type: "string",
      flex: 1.5,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "nombre_sede",
      headerName: "SEDE",
      type: "string",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "estado",
      headerName: "ESTADO",
      type: "string",
      flex: 0.6,
      disableColumnMenu: true,
      sortable: false,
      valueGetter: (params) =>
        params.value != null
          ? params.value === "A"
            ? "Activa"
            : "Inactiva"
          : "No aplica",
    },
  ];

  const newModalField = [
    {
      name: "fecha_creacion",
      label: "Fecha de Creación",
      type: "date",
    },
    { name: "codigo", label: "Código", type: "text" },
    {
      name: "descripcion",
      label: "Nombre de la dependencia/productora",
      type: "text",
    },
    {
      name: "id_unidad_administrativa",
      label: "Unidad Administrativa",
      type: "select",
      options: listUnidadAdministrativa,
    },
    {
      name: "id_sede",
      label: "Sede",
      type: "select",
      options: listSede,
    },
    {
      name: "observacion",
      label: "Observación",
      type: "text",
    },
  ];

  const requiredFields = [
    "codigo",
    "descripcion",
    "id_unidad_administrativa",
    "id_sede",
    "observacion",
  ];

  const loadProductionOffice = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        `dependencia/listar?page=${page + 1}&page_size=${pageSize}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setListOffice(data.results);
        setRowCount(data.count);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadUnidadAdministrativa = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "unidad-administrativa/listar?estado=A",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listaUnidad = data.map((unidad) => {
          return {
            value: unidad.id_unidad_administrativa,
            label: unidad.nombre,
          };
        });
        setUnidadAdministrativa(listaUnidad);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadSedes = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "sedes/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listasede = data.map((sede) => {
          return { value: sede.id_sede, label: sede.nombre };
        });
        setSede(listasede);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleOpenModalTRD = (row) => {
    setOpenModalTRD(true);
    setSelectedRow(row);
  };
  const handleOpenModalTRDSummary = (row) => {
    setOpenModalTRDSummary(true);
    setSelectedRow(row);
    consultarRegistro()
  };

  const handleCloseModalTRDSummary = () => {
    setOpenModalTRDSummary(false);
  };

  const handleCloseModalTRD = () => {
    setOpenModalTRD(false);
  };

  async function handleSaveNewSerie(formData) {
    let usuario = JSON.parse(sessionStorage.getItem("usuario"));
    let datos = {
      ...formData,
      id_usuario: usuario.id_usuario,
    };
    try {
      const updateResponse = await fetch(
        process.env.REACT_APP_PUBLIC_URL + "dependencia/create",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify(datos),
        },
      );
      const result = await updateResponse.json();
      loadProductionOffice();
      showModalAlert("success", "Se creo correctamente la dependencia");
    } catch (error) {
      showModalAlert("danger", "Error al crear la dependencia");
    }
  }

  const onActivate = async (row) => {
    try {
      let usuario = JSON.parse(sessionStorage.getItem("usuario"));
      let dataSend = {
        id_gd_dependencia: row.id_gd_dependencia,
        id_usuario: usuario.id_usuario,
      };
      await fetch(process.env.REACT_APP_PUBLIC_URL + "dependencia/activar", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      });
      loadProductionOffice();
      showModalAlert("success", "Se activo correctamente la dependencia");
    } catch (error) {
      showModalAlert("danger", "Error al activar la depencia");
    }
  };
  const onInactivate = async (row) => {
    try {
      let usuario = JSON.parse(sessionStorage.getItem("usuario"));
      let dataSend = {
        id_gd_dependencia: row.id_gd_dependencia,
        id_usuario: usuario.id_usuario,
      };
      await fetch(process.env.REACT_APP_PUBLIC_URL + "dependencia/inactivar", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      });
      loadProductionOffice();
      showModalAlert("success", "Se inactivo correctamente la dependencia");
    } catch (error) {
      showModalAlert("danger", "Error al inactivar la dependencia");
    }
  };

  const actionsList = [
    {
      title: "Asociar TRD",
      ariaLabel: "add-TRD",
      icon: <AddIcon />,
      onClick: (row) => {
        console.log("row", row);
        handleOpenModalTRD(row);
      },
    },
    {
      title: "Ver TRD",
      ariaLabel: "view-TRD",
      icon: <VisibilityIcon />,
      onClick: (row) => {
        console.log("row 2", row);
        handleOpenModalTRDSummary(row);
      },
    },
  ];

  return (
    <>
      <GeneralTable
        title="Dependencias/Oficinas Productoras"
        titleAlert="Dependencia/Oficina Productora"
        buttonText="Crear Dependencia/Oficina"
        columns={columns}
        rows={listOffice}
        modalFields={newModalField}
        initialFormData={{
          codigo: "",
          descripcion: "",
          fecha_creacion: moment(),
        }}
        onSaveModal={handleSaveNewSerie}
        actionsList={actionsList}
        onActivate={onActivate}
        onInactivate={onInactivate}
        enableActivate
        enableUpdate={false}
        enableDocumentarytype
        enableView={false}
        requiredFields={requiredFields}
        loadList={loadProductionOffice}
        rowCount={rowCount}
        pageSize={pageSize}
        page={page}
        handlePageChange={handlePageChange}
        handlePageSizeChange={handlePageSizeChange}
      />
      {openModalTRD && (
        <DocumentaryTRD
          row={selectedRow}
          openModal={openModalTRD}
          handleCloseModal={handleCloseModalTRD}
        />
      )}
      {openModalTRDSummary && (
        <DocumentaryViewTRD
          row={selectedRow}
          openModal={openModalTRDSummary}
          handleCloseModal={handleCloseModalTRDSummary}
          consultarRegistro={consultarRegistro}
        />
      )}
    </>
  );
}
